import React from "react"
import { FormControl, Grid, MenuItem, Select, Typography } from "@mui/material"
import { StyledSectionCard } from "shared/styled/General"
import { getPeriodOfValidityOptions } from "../constants/examinationSettings"

type Props = {
    t: (key: string, defaultValue?: string) => string
    values: any
    setFieldValue: (field: string, value: any) => void
    examSummaryResult: any
    examSettingsResult?: any
    validityOptionName: (labelId: any) => any
}

export const PeriodOfValiditySection: React.FC<Props> = ({
    t,
    values,
    setFieldValue,
    examSummaryResult,
    examSettingsResult,
    validityOptionName,
}) => {
    const periodOfValidityOptions = getPeriodOfValidityOptions(examSummaryResult?.examinationType)
    return (
        <StyledSectionCard>
            <Grid
                container
                spacing={3}
                display="flex"
                alignItems="center"
                justifyContent="space-between">
                <Grid item md={6}>
                    <Typography mb={1} fontWeight={600} variant="bodyXlarge">
                        {t(`period_of_validity`, "Period of validity")}
                    </Typography>
                    <Typography color="textSecondary" variant="bodyMedium">
                        {t(
                            `validity_text`,
                            "The training validity period is used to control reminders and gives administrators an overview of which participants need to complete the training again."
                        )}
                    </Typography>
                    {examSummaryResult.id === 1 && (
                        <Typography mt={2} fontWeight={500} variant="bodyMedium">
                            {t(
                                `clp_recommend`,
                                "Cloudplanning recommends all our driving and rest training users to complete our digital driving and rest training at least once a year. This is based on the legal cases that exist in the area."
                            )}
                        </Typography>
                    )}
                </Grid>
                <Grid item md={6} lg={4} xl={3} xs={12}>
                    <Typography mb={1} variant="bodyMedium">
                        {t(`validity_time`, "Validity period of the education")}
                    </Typography>
                    <FormControl fullWidth>
                        <Select
                            displayEmpty
                            id="periodOfValidity"
                            value={values.periodOfValidity}
                            onChange={(e) => {
                                setFieldValue("periodOfValidity", e.target.value)
                            }}>
                            {periodOfValidityOptions?.map((item: any, index: number) => {
                                return (
                                    <MenuItem key={index} value={item.value}>{t(validityOptionName(item.labelId))}</MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </StyledSectionCard>
    )
}
